import { useState } from "react";
import { SendToast } from "@networkraildigitalfactory/components";
import { Regexes } from "../../services/utils";
import { useUsers } from "../useAPI";

const useAdminExport = () => {
  const [searchValue, setSearchValue] = useState("");
  const [searchCriteria, setSearchCriteria] = useState("getEmployeeByEmpNo");
  const [inputError, setInputError] = useState("");
  const [exportMenu, setExport] = useState();

  const [results, getResults] = useUsers(
    {
      url: `admin/${searchCriteria}/${searchValue}`,
      method: "GET",
    },
    { manual: true }
  );

  const displayErrorMessage = () => {
    if (searchCriteria === "getEmployeeByEmpNo" && searchValue === "") {
      setInputError("Must not be blank");
    } else {
      setInputError("Must be a valid email address");
    }
  };

  const toggleSearch = () => {
    setSearchValue("");
    setInputError("");
    if (searchCriteria === "getEmployeeByEmpNo") {
      setSearchCriteria("getEmployeeByEmail");
    } else {
      setSearchCriteria("getEmployeeByEmpNo");
    }
  };

  const search = async () => {
    setInputError("");
    setExport(false);
    if (
      (searchValue !== "" &&
        searchCriteria === "getEmployeeByEmail" &&
        searchValue.match(Regexes.email)) ||
      (searchCriteria === "getEmployeeByEmpNo" && searchValue !== "")
    ) {
      try {
        await getResults();
      } catch (e) {
        console.error(e);
        SendToast(`Search could not be completed at this time. Please try again`, "error");
      }
    } else {
      displayErrorMessage();
    }
  };

  return {
    results: results.data,
    searchValue,
    searchCriteria,
    setSearchValue,
    setSearchCriteria,
    search,
    inputError,
    setInputError,
    exportMenu,
    setExport,
    toggleSearch,
  };
};

export default useAdminExport;
